import { useLocation } from "react-router-dom";
import StockRecordPage from "./StockRecordPage";

const PurchaseRecords = () => {
    const { pathname } = useLocation();
    return (
        <StockRecordPage
            type="purchase"
            title="Purchase Records"
            navId={pathname}
            metaKey="purchaseRecords"
            apiBase="/api/v1/purchase-records"
            breadcrumbParent={pathname.startsWith("/admin") ? "Admin" : "Dashboard"}
        />
    );
};

export default PurchaseRecords;
